// extracted by mini-css-extract-plugin
export default {"heading":"custom-heading_heading__aeN6D","headingPrimary":"custom-heading_headingPrimary__ZAdX1","headingSecondary":"custom-heading_headingSecondary__FBCLd"};